"use client";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useAtom } from "jotai";
import { fromDataAtom } from "@/scripts/store";
import Link from "next/link";
import SVG from "react-inlinesvg";

export default function PageComponent({ sectionTitle, slug }) {
  const router = useRouter();
  const [fromData, set_fromData]: any = useAtom(fromDataAtom);
  const [isLoading, set_isLoading]: any = useState(false);

  // console.log(fromData);
  const onSubmit = async (e: any) => {
    e.preventDefault();
    const form: HTMLFormElement = e.target;

    // router.push('/contact/complete/')

    // const resend = new Resend('re_UPRvQFHa_6dJHivp4mGGBn3RUvUCzjH6P');
    // const { data, error } = await resend.emails.send({
    //   from: 'onboarding@resend.dev',
    //   to: formDataObject["email"],
    //   subject: `サイトからお問い合わせがありました`,
    //   html: `
    //   お問い合わせ要件 : ${formDataObject["subject"]}
    //   名前 : ${formDataObject["name"]}
    //   フリガナ : ${formDataObject["name-kana"]}
    //   メールアドレス : ${formDataObject["email"]}
    //   電話番号 : ${formDataObject["tel"]}
    //   郵便番号 : ${formDataObject["zip"]}
    //   住所 : ${formDataObject["address"]}
    //   お問い合わせ内容 : ${formDataObject["message"]}
    //   `
    // });
    // if (error) {
    //   return console.error({ error });
    // }
    // console.log({ data });

    set_isLoading(true);

    const res = await fetch(form.action, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(fromData),
    });

    const resData = await res.json();
    if (res.ok) {
      console.log("OK", resData);
      set_fromData(null);
      router.push(`/contact/${slug}/complete/`);
    } else {
      set_isLoading(false);
      console.log("エラー", resData);
    }
  };

  return (
    <main className="page page-contact">
      <div className="container-s">
        <div className="page-title-holder">
          <h1 className="h1-title">
            <span className="shoulder">お問い合わせ</span>
            <span className="title en">Contact</span>
          </h1>
        </div>

        <section className="section-contact">
          {fromData && fromData.sectionTitle ? (
            <>
              <div className="section-contact-title">
                <div className="title bold">{fromData && fromData.sectionTitle}</div>
                <div className="text-lead">入力内容をご確認ください。</div>
              </div>

              {fromData.data && (
                <form action="/api/mail/" method="post" onSubmit={onSubmit}>
                  <ul className="underline-list">
                    <li className="underline-list-item">
                      <div className="title">お問い合わせ要件</div>
                      <div className="text">{fromData.data["subject"]}</div>
                    </li>

                    <li className="underline-list-item">
                      <div className="title">お名前</div>
                      <div className="text">{fromData.data["name"]}</div>
                    </li>

                    <li className="underline-list-item">
                      <div className="title">会社名・屋号</div>
                      <div className="text">{fromData.data["company_name"]}</div>
                    </li>

                    <li className="underline-list-item">
                      <div className="title">部署名・役職</div>
                      <div className="text">{fromData.data["position"]}</div>
                    </li>

                    <li className="underline-list-item">
                      <div className="title">ウェブサイトURL</div>
                      <div className="text">{fromData.data["website"]}</div>
                    </li>

                    <li className="underline-list-item">
                      <div className="title">メールアドレス</div>
                      <div className="text">{fromData.data["email"]}</div>
                    </li>

                    {fromData.data["tel"] && (
                      <li className="underline-list-item">
                        <div className="title">電話番号（携帯）</div>
                        <div className="text">{fromData.data["tel"]}</div>
                      </li>
                    )}

                    {fromData.data["address"] && (
                      <li className="underline-list-item">
                        <div className="title">所在地(市区町村)</div>
                        <div className="text">{fromData.data["address"]}</div>
                      </li>
                    )}

                    {fromData.data["cultivation_area"] && (
                      <li className="underline-list-item">
                        <div className="title">栽培管理面積</div>
                        <div className="text">{fromData.data["cultivation_area"]}</div>
                      </li>
                    )}

                    {[1, 2, 3, 4, 5, 6].map((n) => fromData.data[`farming_method_${n}`]).filter((b) => b).length>0 && (
                      <li className="underline-list-item">
                        <div className="title">農法</div>
                        <div className="text">
                          {[1, 2, 3, 4, 5, 6]
                            .map((n) => fromData.data[`farming_method_${n}`])
                            .filter((b) => b)
                            .join("、 ")}
                        </div>
                      </li>
                    )}

                    {fromData.data["cultivated_crops"] && (
                      <li className="underline-list-item">
                        <div className="title">栽培作物</div>
                        <div className="text">{fromData.data["cultivated_crops"]}</div>
                      </li>
                    )}

                    <li className="underline-list-item">
                      <div className="title">お問い合わせ内容</div>
                      <div className="text whitespace-pre-line">{fromData.data["message"]}</div>
                    </li>
                  </ul>
                  <div className="button-holder confirm">
                    <button
                      className="button-back"
                      onClick={() => {
                        router.back();
                      }}
                      type="button"
                    >
                      <i className="icon-arrow">
                        <SVG src="/assets/img/common/icon/icon-arrow-left.svg" />
                      </i>
                      入力内容を変更する
                    </button>
                    <button className="button-submit button-round scaleHover" type="submit">
                      <span className="inner">
                        送信{isLoading && <span className="loading mailSending">中</span>}
                      </span>
                    </button>
                  </div>
                </form>
              )}
            </>
          ) : (
            <>
              <div className="page-title-holder">
                <div className="text-lead bold">
                  お問い合わせフォームより
                  <br />
                  お問い合わせください
                </div>
              </div>

              <div className="button-holder">
                <Link className="button-round scaleHover size-s bold" href="../">
                  <div className="inner">もどる</div>
                </Link>
              </div>
            </>
          )}
        </section>
      </div>
    </main>
  );
}
